import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { WishlistService } from 'src/app/services/wishlist.service';

@Component({
  selector: 'wishlist',
  templateUrl: './wishlist.component.html',
  styleUrls: ['./wishlist.component.less']
})
export class WishlistComponent implements OnInit {
  @Input() wishList: any = [];
  allChecked:boolean=false;
  debounceTimer: any = null;
  pagination = {
    total: 50,
    pageIndex: 1,
    pageSize: 20,
    pageSizeOptions: [10, 20, 50],
  };
item: any;
  constructor(private wishlistService:WishlistService) {
    this.wishList.forEach((data:any) => data.check = false);
  }

  ngOnInit(): void {

  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['wishList']) {
      if(this.wishList.length==0){
        this.allChecked=false;
      }else{
        this.updateAllChecked();
      }

    }
  }
  pageSizeChange(pageSize: number) {
    this.pagination.pageSize = pageSize;
    this.pagination.pageIndex = 1;
    //this.getList();
  }

  selectAll(checked: boolean) {
    this.allChecked = checked;
    this.wishList.forEach((data:any) => data.check = checked);
  }

  updateAllChecked() {
    this.allChecked = this.wishList.every((data:any) => data.check);
  }

  isOperation(){
    return this.wishList.length == 0 || this.wishList.filter((item: any) => item.check)?.length == 0;
  }


  moveToCart(ids?:number[]):void{
    if(!ids){
      ids = this.wishList.filter((item:any) => item.check).map((item:any) => item.id);
    }
    this.wishlistService.moveToCart(ids);
  }

  deleteAll():void{
    let params = this.wishList.filter((item:any) => item.check).map((item:any)=>item.id);
    this.wishlistService.deleteAll(params);
  }

  pageIndexChange(pageIndex: number) {
    this.pagination.pageIndex = pageIndex;
   // this.getList();
  }
  updateFromWishList(product: any): void {
    this.wishlistService.updateWishList(product);
  }
  quantityBlur(newQuantity: number, item: any) {
    item.quantity = newQuantity;
    item.inputQuantity = newQuantity;
  }

  quantityChange(newQuantity: number, item: any) {
    if(item.quantity==item.inputQuantity){
      return;
    }
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
    this.debounceTimer = setTimeout(() => {
      item.quantity = newQuantity;
      this.updateFromWishList(item);
    }, 1000);
  }
}
